import React from "react";
import styles from "./LightButton.module.scss";

const LightButton = (props: any) => {
  return (
    <button
      className={`${styles.lightButton} ${props.className}`}
      onClick={props.onClick}
      type={props.type ?? "button"}
    >
      {props.children}
    </button>
  );
};

export default LightButton;
